"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileName = getFileName;
exports.getFileFromDatasheet = getFileFromDatasheet;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var formats = _interopRequireWildcard(require("../formats"));

var _extensions;

var _window = window,
    XLSX = _window.XLSX;
var defaultSheetName = 'Sheet1';
var extensions = (_extensions = {}, (0, _defineProperty2.default)(_extensions, formats.XLSX_FORMAT, 'xlsx'), (0, _defineProperty2.default)(_extensions, formats.XLS_FORMAT, 'xls'), (0, _defineProperty2.default)(_extensions, formats.CSV_FORMAT, 'csv'), (0, _defineProperty2.default)(_extensions, formats.JSON_FORMAT, 'json'), _extensions); // For an explanation of where these come from, check out:
// https://github.com/sheetjs/js-xlsx#supported-output-formats

var csvBookType = 'csv'; // Comma separated values

var xlsBookType = 'biff8'; // Excel 97-2004 workbook format

var xlsxBookType = 'xlsx'; // Excel 2007+ workbook format

function convertToJson(rows, columns) {
  return JSON.stringify({
    rows: rows,
    columns: columns
  }, null, 2);
}

function convertToWorkbook(rows, columns, bookType) {
  var serializedRows = rows.map(function (row) {
    return columns.map(function (column) {
      return row[column];
    });
  });
  var datasheet = [columns].concat((0, _toConsumableArray2.default)(serializedRows));
  var worksheet = XLSX.utils.aoa_to_sheet(datasheet);
  var workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, defaultSheetName);
  return XLSX.write(workbook, {
    bookType: bookType,
    type: 'array'
  });
}

function getFileName(fileName, fileType) {
  var validatedFileType = extensions[fileType] ? fileType : formats.XLSX_FORMAT;
  return "".concat(fileName, ".").concat(extensions[validatedFileType]);
}

function getFileFromDatasheet(rows, columns, fileType) {
  switch (fileType) {
    case formats.CSV_FORMAT:
      return convertToWorkbook(rows, columns, csvBookType);

    case formats.JSON_FORMAT:
      return convertToJson(rows, columns);

    case formats.XLS_FORMAT:
      return convertToWorkbook(rows, columns, xlsBookType);

    case formats.XLSX_FORMAT:
      return convertToWorkbook(rows, columns, xlsxBookType);

    default:
      return convertToWorkbook(rows, columns, xlsxBookType);
  }
}